import { useEffect, useRef, type FC } from 'react';

// Arquivo em JS puro de propósito: o app nativo embute ESTE mesmo código dentro de um
// WebView (`npm run confete:sync`, em apps/mobile), e um .ts não rodaria lá sem compilação.
import { desenharConfete } from './confeteCanvas';
import styles from './Confete.module.scss';

// O CONFETE DAS TELAS DE SUCESSO DE PAGAMENTO, desenhado em canvas (sem dependência): toca UMA vez,
// some, não bloqueia clique e não aparece para quem pediu para reduzir o movimento.
export const Confete: FC<{ duracaoMs?: number }> = ({ duracaoMs = 2600 }) => {
  const canvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const reduzir = typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduzir || !canvas.current) return undefined;
    return desenharConfete(canvas.current, { durationMs: duracaoMs });
  }, [duracaoMs]);

  return <canvas ref={canvas} aria-hidden className={styles.confete} />;
};
